import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";
export default store => ({
  path: "class-flow",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "class-flow" */ "./components"),
        import(
          /* webpackChunkName: "class-flow" */ "./modules/ClassMaterialsModule"
        ),
        import(
          /* webpackChunkName: "class-flow" */ "AppComponents/EntityFlowComponents/ImportFromUnitFlowModal/modules/Module"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const importFromUnitFlowModalReducer = importedModule2.default;
        injectReducer(store, {
          key: "classMaterials",
          reducer,
        });
        injectReducer(store, {
          key: "importFromUnitFlow",
          reducer: importFromUnitFlowModalReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ClassRoomDetails(store)],
});
